
export default function Services() {
  const services = [
    {
      icon: 'ri-search-line',
      title: 'Latin America Supplier Sourcing & Qualification',
      description: 'Comprehensive supplier identification, vetting, and qualification across Latin America to ensure quality and reliability. We provide on-site supplier inspections and facility assessments in Venezuela and Colombia to support quality and compliance.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'RFQs and Price Benchmarking',
      description: 'Strategic request for quotations and competitive price analysis to secure the best terms for your procurement needs.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Contract Negotiation & Commercial Terms',
      description: 'Expert negotiation of contracts and commercial terms to maximize value and minimize risk in supplier relationships.'
    },
    {
      icon: 'ri-ship-line',
      title: 'Incoterms and Freight Strategy',
      description: 'Optimized freight strategies and Incoterms selection to reduce shipping costs and streamline logistics operations.'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Landed Cost Analysis',
      description: 'Detailed analysis of total landed costs including duties, freight, and fees to provide complete cost transparency.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Local Legislation & Compliance Analysis',
      description: 'We analyze local legislation in each sourcing country to ensure full regulatory compliance, mitigate legal risks, and protect your supply chain operations.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Ongoing Procurement Support',
      description: 'Continuous support and management of your procurement operations to ensure smooth supply chain execution.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Services
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Procurement Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            End-to-end procurement management designed to reduce costs and improve supplier relationships
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
